export default __webpack_public_path__ + "static/media/table.ca125a29.svg";